// project-imports
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //
//
// The template also rendered a promo card under the navigation linking to the theme author's
// support desk. It has no place in a dashboard for the sales floor.

const DrawerContent = () => (
  <SimpleBar
    sx={{
      // let the scroller take only the space left under the logo, not the full paper height
      height: 'auto',
      minHeight: 0,
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column'
      }
    }}
  >
    <Navigation />
  </SimpleBar>
);

export default DrawerContent;
